import * as React from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

import { useChoixTheme, type ChoixTheme } from '../Theme/ThemeApplication.tsx';

// Apparence (page Mes preferences) : automatique (suit le systeme), clair
// ou sombre. Le choix est memorise sur cet appareil.
export default function ApparenceEditeur() {
  const { choix, mode, choisir } = useChoixTheme();

  return (
    <Box id="preference-apparence" sx={{ mt: 4 }}>
      <h2>Apparence</h2>
      <Typography sx={{ mb: 2 }} color="text.secondary">
        En automatique, l'application passe en mode sombre quand ton appareil l'est (réglage du système, souvent selon
        l'heure). Tu peux aussi imposer le mode clair ou le mode sombre. Ce choix est mémorisé sur cet appareil.
      </Typography>
      <ToggleButtonGroup
        exclusive
        value={choix}
        onChange={(_e, v: ChoixTheme | null) => v && choisir(v)}
        aria-label="Apparence"
        sx={{ '& .MuiToggleButton-root': { textTransform: 'none', gap: 1, px: 2 } }}
      >
        <ToggleButton value="auto"><BrightnessAutoIcon fontSize="small" />Automatique</ToggleButton>
        <ToggleButton value="clair"><LightModeIcon fontSize="small" />Clair</ToggleButton>
        <ToggleButton value="sombre"><DarkModeIcon fontSize="small" />Sombre</ToggleButton>
      </ToggleButtonGroup>
      {choix === 'auto' && (
        <Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
          Actuellement : mode {mode === 'dark' ? 'sombre' : 'clair'}, comme ton système.
        </Typography>
      )}
    </Box>
  );
}
